import { ClipboardList, ClipboardPen } from 'lucide-react'
import { FormsSpaceFields } from '@/components/features/forms/FormsSpaceFields'
import { defaultFormsConfig, formsConfigApiErrors, formsConfigOf } from '@/components/features/forms/formsSpaceConfig'
import { sdk } from '@/lib/sdk'
import { isEmptyList } from '../emptyList'
import type { ModuleDefinition } from '../types'
import { lazyPage } from '@/lib/lazyPage'

const FormsPage = lazyPage(() => import('@/pages/Forms'), 'FormsPage')

export const formsModule: ModuleDefinition = {
  key: 'forms',
  icon: ClipboardPen,
  iconName: 'clipboard-pen',
  namespaces: ['forms'],
  ready: true,
  ListPage: FormsPage,
  /* "One form" or "Several forms" (F-109): short, so it sits on the details step. */
  setup: {
    wizardStep: 'details',
    defaultConfig: () => defaultFormsConfig(),
    validate: () => null,
    errorsFromApi: (err) => formsConfigApiErrors(err),
    Fields: FormsSpaceFields,
    persist: {
      type: 'moduleConfig',
      toModuleConfig: (config, stored) => ({ ...(stored || {}), mode: config?.mode === 'single' ? 'single' : 'multi' }),
      fromSpace: (space) => formsConfigOf(space.moduleConfig as Record<string, unknown> | null | undefined)
    }
  },
  singleItem: { isEmpty: async (spaceId) => isEmptyList(await sdk.forms.list({ spaceId, limit: 1 })) },
  workflow: { trigger: { block: 'forms', icon: ClipboardList, families: ['form'] } }
}
